import { AxiosResponse } from "axios";
import { AltiusRes, IOpportunities } from "store/types";

import { DealAction } from "../actions";
import { AsyncActions, AsyncActionsParams } from "../base";

export interface IOpportunitiesActions {
  getOpportunitiesAction: () => Promise<void>;
  updateOpportunitiesStatusAction: (data: { id: number; status: string }) => Promise<IOpportunities>;
  sendOpportunityEventAction: (data: { id: number; event: string }) => Promise<void>;
}

export class OpportunitiesActions extends AsyncActions implements IOpportunitiesActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public getOpportunitiesAction: IOpportunitiesActions["getOpportunitiesAction"] = async (): Promise<void> => {
    const {
      data: { data: payload }
    }: AxiosResponse<AltiusRes<IOpportunities[]>> = await this.api.get({
      url: "/api/v0.0.3/opportunities"
    });
    this.dispatch({ type: DealAction.GetOpportunitiesSuccess, payload });
  };

  public updateOpportunitiesStatusAction: IOpportunitiesActions["updateOpportunitiesStatusAction"] = async (data: {
    id: number;
    status: string;
  }): Promise<IOpportunities> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<AltiusRes<IOpportunities>> = await this.api.patch({
        url: `/api/v0.0.3/opportunities/${data.id}/status`,
        data: { status: data.status }
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public sendOpportunityEventAction: IOpportunitiesActions["sendOpportunityEventAction"] = async (data) => {
    await this.api.post({
      url: `/api/v0.0.3/opportunities/${data.id}/event`,
      data: { event: data.event }
    });
  };
}
